import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Users, CalendarCheck, Bell, MapPin, ArrowRight } from "lucide-react";

export default function ParentHome() {
  const [children, setChildren] = useState([]);
  const [reservations, setReservations] = useState([]);
  const [notifications, setNotifications] = useState([]);
  const [missions, setMissions] = useState([]);

  useEffect(() => {
    Promise.all([
      api.get("/children"),
      api.get("/reservations"),
      api.get("/notifications"),
      api.get("/missions"),
    ]).then(([c, r, n, m]) => {
      setChildren(c.data); setReservations(r.data); setNotifications(n.data); setMissions(m.data);
    });
  }, []);

  const unread = notifications.filter((n) => !n.read).length;
  const activeMission = missions.find((m) => m.status === "active");

  return (
    <div className="p-4 pb-6" data-testid="parent-home-page">
      <div className="mb-5">
        <div className="text-[10px] font-mono tracking-[0.3em] uppercase text-zinc-500">Bonjour</div>
        <h1 className="font-display font-black text-3xl tracking-tighter">Votre journée</h1>
      </div>

      {activeMission ? (
        <Link to={`/parent/tracking/${activeMission.id}`} data-testid="active-mission-banner" className="block border border-zinc-900 bg-[#FFC60A] p-4 mb-4 hover:bg-[#ffd43a]">
          <div className="flex items-center justify-between">
            <div>
              <div className="text-[10px] font-mono tracking-[0.3em] uppercase">Live maintenant</div>
              <div className="font-display font-bold text-lg mt-0.5">{activeMission.route?.name}</div>
              <div className="text-xs mt-1 flex items-center gap-1 font-mono"><MapPin size={12} /> En route</div>
            </div>
            <ArrowRight size={22} />
          </div>
        </Link>
      ) : (
        <div className="border border-zinc-900 p-4 mb-4">
          <div className="text-[10px] font-mono tracking-[0.3em] uppercase text-zinc-500">À venir</div>
          <div className="font-display font-bold text-lg mt-0.5">Aucun trajet en cours</div>
          <div className="text-xs mt-1 text-zinc-500">Les alertes temps réel apparaîtront ici.</div>
        </div>
      )}

      <div className="grid grid-cols-3 gap-0 border border-zinc-900 mb-4">
        <div className="p-3 text-center border-r border-zinc-900">
          <Users className="mx-auto" size={16} />
          <div className="font-display font-black text-2xl tracking-tighter mt-1">{children.length}</div>
          <div className="text-[10px] font-mono tracking-widest uppercase text-zinc-500">Enfants</div>
        </div>
        <div className="p-3 text-center border-r border-zinc-900">
          <CalendarCheck className="mx-auto" size={16} />
          <div className="font-display font-black text-2xl tracking-tighter mt-1">{reservations.filter((r) => r.status === "confirmed").length}</div>
          <div className="text-[10px] font-mono tracking-widest uppercase text-zinc-500">Résa actives</div>
        </div>
        <div className="p-3 text-center">
          <Bell className="mx-auto" size={16} />
          <div className="font-display font-black text-2xl tracking-tighter mt-1">{unread}</div>
          <div className="text-[10px] font-mono tracking-widest uppercase text-zinc-500">Nouvelles</div>
        </div>
      </div>

      <div className="border border-zinc-900" data-testid="recent-notifications">
        <div className="p-3 bg-zinc-900 text-white text-[10px] font-mono tracking-widest uppercase">Dernières alertes</div>
        <div className="divide-y divide-zinc-200 max-h-80 overflow-y-auto">
          {notifications.slice(0, 6).length === 0 ? (
            <div className="p-4 text-xs text-zinc-500">Aucune notification.</div>
          ) : notifications.slice(0, 6).map((n) => (
            <div key={n.id} className={`p-3 ${n.read ? "opacity-70" : ""}`}>
              <div className="flex justify-between">
                <div className="font-semibold text-sm">{n.title}</div>
                <div className="text-[10px] font-mono text-zinc-500">{n.created_at.slice(11, 16)}</div>
              </div>
              <div className="text-xs text-zinc-600 mt-0.5">{n.body}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
